import React from 'react';
import { Button, Flex, Image, Spinner, Text, Tooltip } from '@chakra-ui/react';
import { ITile } from './onboarding';
import { IconCheckmark, Type } from '../../../utils/icons/iconCheckmark';
import { Color } from 'src/theme/color';

export const OnboardingTile = ({ isCompleted, action, content, isHalfCompletable }: ITile) => {
	return (
		<Tooltip
			label="Coming soon"
			placement="bottom-end"
			isDisabled={content.enumerator !== '4.'}
		>
			<Button
				variant="hoverable"
				display="flex"
				width="auto"
				onClick={action}
				disabled={!!isCompleted && !isHalfCompletable}
				height="auto"
				background="backgroundLight"
				border="1px solid"
				borderColor="backgroundLight"
				borderRadius="4px"
				position="relative"
				padding="0"
				justifyContent="start"
				_last={{ opacity: '.25' }}
			>
				<Flex
					height="100%"
					px="8px"
					borderRight="1px solid"
					borderColor="backgroundLight"
					alignItems="center"
					justifyContent="center"
				>
					{isCompleted === null ? (
						<Spinner
							w="16px"
							h="16px"
							thickness="1.5px"
							color="#333131"
						/>
					) : (
						<IconCheckmark
							type={isCompleted || (isHalfCompletable && isCompleted) ? Type.DONE : Type.UNDONE}
						/>
					)}
				</Flex>
				<Flex
					width="100%"
					padding="16px 12px"
				>
					<Flex gridGap="12px">
						<Image src={content.header.iconUri} />
						<Flex
							direction="column"
							gap="1px"
							textAlign="start"
						>
							<Text
								fontSize="14px"
								lineHeight="20px"
								fontWeight="500"
							>
								{content.header.title}
							</Text>
							<Text
								textAlign="start"
								fontSize="10px"
								lineHeight="14px"
								fontWeight="300"
							>
								{content.description}
							</Text>
						</Flex>
					</Flex>
					<Text
						color={Color.BACKGROUND_TERTIARY}
						opacity=".5"
						fontSize="9px"
						fontWeight="500"
						lineHeight="13px"
						position="absolute"
						bottom="6px"
						right="8px"
					>
						{content.enumerator}
					</Text>
				</Flex>
			</Button>
		</Tooltip>
	);
};
